<template>
<v-dialog v-model="inheritRolesDialog" persistent max-width="1000">
    <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          icon
          class="mr-2"
          v-bind="attrs"
          v-on="on"
          :disabled="disable"
        >
          mdi-checkbox-multiple-outline
        </v-icon>
    </template>
    <v-card class="qmkey-notifications-table mx-auto">
      <v-card-title>
        <span class="modal-title">{{ $vuetify.lang.translator("labels.parent_roles_inheritance") }}</span>
        <v-spacer style="max-width: 100px"></v-spacer>
        <v-text-field
          v-model="search"
          ref="rolesSearchableText"
          prepend-inner-icon="mdi-magnify"
          :label="$vuetify.lang.translator('search_text')"
          single-line
          hide-details
          style="float:right"
          class="department-searchable-text"
          :class="{ 'closed' : searchClosed}"
          solo
          flat
          clearable    
          dense
          filled
          background-color="white"
          @click:prepend-inner="toogleSearch($event)"
          @blur="toogleSearch($event)"
        >
        </v-text-field>
        <v-spacer></v-spacer>
        <v-btn
          color="black"
          text @click="inheritRolesDialog = false"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
        <v-card-text>
          <v-data-table
            v-model="selectedRoles"
            :items="roles"
            :headers="roleFields"
            dense
            item-class="qmkey-item-row"
            sortBy="department_name"
            show-select
            fixed
            :search="search"
          >
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            small
            class=""
            @click="setInheritRoles"
          >
            Update
          </v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>  
</template>


<script>
import Roles from '@/api/Roles'

export default {
  name: 'InheritRoles',

  props: {
     sitePath: {required: true},
     disable: {type: Boolean,default: false},
   },

  data() {
    return {
      search: '',
      expanded: [],
      inheritRolesDialog: false,
      searchClosed: true,
      roles: [],
      selectedRoles: [],
      tabs: null,

      inheritRoles: [],
      
      roleFields: [
        {
          text: 'Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Department',
          sortable: true,
          value: 'department_name',
        },
        {
          text: 'Parent',
          sortable: true,
          value: 'parent_name',
        },
        { value: 'description', text: 'Description', sortable: true },
      ],
    }
  },

  computed: {
    sort_icon() {
      return this.unitsSortDesc ? 'mdi-sort-descending' : 'mdi-sort-ascending';
    },

    parent_site() {
      let parent = this.sitePath.split('/');
      parent.pop();
      return parent.length>1 ? parent.join('/') : null
    },
  },

  mounted: function() {
    this.getRoles();
    this.getInheritRoles();
  },
  

  methods: {
    getRoles() {
      if (!this.disable && this.parent_site) {
        Roles.get(this.parent_site)
          .then((response) => {
            this.roles = response.results;
          })
          .catch((err) => {
            console.log(err);
          })
      }
    },
    getInheritRoles(){
      if(!this.disable){
        Roles.listInheritance(this.sitePath)
          .then((response) => {
            this.inheritRoles = response;
            this.selectedRoles = response;
          })
          .catch((err) => {
            console.log(err);
          })
      }
    },
    refreshRolesOfDepartment(department_id) {
      this.selectedRoles[department_id] = this.roles.filter(
        (role) => role.department == department_id,
      );
    },
    rolesOfDepartment(department_id) {
      return this.roles.filter((role) => role.department == department_id);
    },

    setInheritRoles(){
      const selected = this.selectedRoles.map(v => v.id);
      const inherit = this.inheritRoles.map(v => v.id);
      let result = {'roles': selected.filter(v => !inherit.includes(v)).concat(inherit.filter(v => !selected.includes(v)))};

      Roles.editInheritance(this.sitePath, result)
        .then(() => {
          this.getRoles();
          this.getInheritRoles();
          this.inheritRolesDialog = false;
          this.$emit('refresh');
        })
        .catch((err) => {
          console.log(err);
        })
    },

    toogleSearch: function(evt) {
      if (this.searchClosed){
        this.$refs.rolesSearchableText.focus();
      }
      if (!this.search_text) {
        this.searchClosed = !this.searchClosed;
      }
    },
  },
  watch: {
    inheritRolesDialog(){
      if (!this.inheritRolesDialog) {
        this.selectedRoles = this.inheritRoles;
      }
    }
  }
}
</script>
